import Toast from "react-native-toast-message";
import React from "react";
import { View, StyleSheet } from "react-native";
import color from "@constants/color";
import FastImage from "@d11/react-native-fast-image";
import Text from "./CustomText";

const ToastMessage = (toastType, msg, visibilityTime = 3000, position) => {
  if (msg) {
    return Toast.show({
      type: toastType,
      position: position || "bottom",
      text1: msg || toastType.toUpperCase(),
      bottomOffset: 30,
      visibilityTime,
    });
  }
};

const ToastBody = ({ msg, bgColor, textColor }) => {
  return (
    <View
      style={[styles.container, { backgroundColor: bgColor || color.black }]}
    >
      <Text style={[styles.msgText, { color: textColor }]}>{msg}</Text>
    </View>
  );
};

const ToastBody2 = ({ msg }) => {
  return (
    <View style={[styles.container, styles.container2]}>
      <View style={styles.gifContainer}>
        <FastImage
          style={styles.gif}
          resizeMode="contain"
          source={{
            uri: "https://public-cdn.citymall.live/cm-admin-storage-public/cl_app_icon%2F1674640247699-79952-successful.gif",
          }}
        />
      </View>
      <Text
        newFont
        style={[styles.msgText, { color: color.mediumBlack, flex: 1 }]}
      >
        {msg}
      </Text>
    </View>
  );
};

export const ToastConfig = {
  info: ({ text1 }) => <ToastBody msg={text1} textColor="white" />,
  success: ({ text1 }) => (
    <ToastBody bgColor={color.plain_green} msg={text1} textColor="white" />
  ),
  success2: ({ text1 }) => <ToastBody2 msg={text1} />,
  simple: ({ text1 }) => <ToastBody msg={text1} textColor="white" />,
};

const styles = StyleSheet.create({
  container: {
    height: 50,
    width: "94%",
    borderRadius: 6,
    justifyContent: "center",
    paddingHorizontal: 24,
  },
  msgText: {
    fontFamily: "NotoSansDevanagari-SemiBold",
    fontSize: 14,
    fontWeight: "500",
    textAlign: "left",
    color: "#ffffff",
  },
  container2: {
    backgroundColor: color.white,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    overflow: "hidden",
    height: 76,
    paddingVertical: 8,
    paddingLeft: 8,
    borderRadius: 10,
    elevation: 4,
  },
  gifContainer: {
    width: 76,
    height: 76,
    alignItems: "center",
    justifyContent: "center",
  },
  gif: {
    height: 140,
    width: 140,
  },
});

export default ToastMessage;
